import { logout_white, profile_circle_primary } from '@assets/icons';
import { Box, Popover } from '@mui/material';
import { Text } from '../common/Text';
import { colorSet } from '@theme';
import { RootState, useSelector } from '@stores';
import { useAuthActions } from '@remote-hooks';

interface ILogoutPopoverContentProps {
  handlePopoverClose: () => void;
}

interface ILogoutPopoverProps {
  anchorEl: HTMLImageElement | null;
  handlePopoverClose: () => void;
}

const LogoutPopoverContent = (props: ILogoutPopoverContentProps) => {
  const { handlePopoverClose } = props;

  const storedAuth = useSelector((state: RootState) => state.auth);

  const { onLogout } = useAuthActions();

  return (
    <Box
      width={267}
      minHeight={120}
      padding={'12px 16px'}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box height="auto" display="flex" flexDirection="row" alignItems="flex-start" marginBottom="24px">
        <img src={profile_circle_primary} style={{ marginRight: 8 }} />
        <div>
          <Text variant="body1" fontWeight="bold" style={{ width: 187, wordBreak: 'break-all' }}>
            {storedAuth.name}
          </Text>
          <Text variant="body1" style={{ width: 187, wordBreak: 'break-all' }}>
            {storedAuth.email}
          </Text>
        </div>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="flex-end">
        <Box
          onClick={() => {
            handlePopoverClose();
            onLogout();
          }}
          width={112}
          height={32}
          bgcolor={colorSet.primaryMain}
          borderRadius={'22px'}
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ cursor: 'pointer' }}
        >
          <Box display="flex" flexDirection="row" alignItems="center">
            <img src={logout_white} style={{ width: 20, height: 20, marginRight: 4 }} />
            <Text variant="body2" color="white" fontWeight="bold">
              로그아웃
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const LogoutPopover = (props: ILogoutPopoverProps) => {
  const { anchorEl, handlePopoverClose } = props;

  return (
    <Popover
      id="menu-top-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      sx={{
        '.MuiPopover-paper': {
          boxShadow: '0px 4px 10px rgba(0,0,0,0.1)'
        }
      }}
      disableScrollLock={true}
    >
      <LogoutPopoverContent handlePopoverClose={handlePopoverClose} />
    </Popover>
  );
};
